
import React, { useCallback, useMemo, useState } from 'react';
import { useSign, SET_MISSING_VARS, useSignState } from 'context/signview';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useEditor } from 'slate-react';
import { FormProvider, useFormContext, useForm } from 'react-hook-form';
import { AttachmentItem } from './attachments';
import { scrollToNode } from 'components/Editor/Canvas/TratoFormat/editor-utils';
import { VariableInput } from 'components/Editor/Sidebar/Contents';
import { format, getIsVariableFilled } from 'utils';
import { agendaFields } from 'components/Modals/AgendaModal';



function Variable({ variable = {} }) {
    const editor = useEditor();
    const  { t } = useTranslation();
    
    const [isVariableFilled, setIsVariableFilled] = useState(getIsVariableFilled(variable));
    const [{ contract, variablesMissing }, dispatch] = useSign();
    const variableName = contract.isMigrated ? `v-${variable._id}`: variable.apiName;

    const methods = useFormContext();
    const locale = contract?.language?.toLowerCase?.() || 'es';

    console.log({variable})

    const { _id, apiName, value, name, type, required, limit, isLimitRequired, isAgendaProperty } = useMemo(() => {
        if (contract.isMigrated) {
            if (variable.apiName.includes('agendaProperties.')) {
                const [,propertyName] = variable.apiName.split('.');
                const field = agendaFields.find(af => af.propertyName === propertyName)
                return { 
                    ...variable,
                    isAgendaProperty: variable.apiName.includes('agendaProperties.'),
                    type: field.type === 'calendar' ? 'date' : 'text',
                    name: t(`agenda.${propertyName}_placeholder`),
                    value: contract?.signViewOptions?.currentParticipant?.agendaProperties?.[propertyName] || ''
                }
            }
            return contract.participants.flatMap(p => p.variables).find(v => v._id === variable._id) || {}; 
        }
        return variable;
    }, [variable, contract.isMigrated, contract.participants, contract?.signViewOptions?.currentParticipant?.agendaProperties, t])
   
    const handleSelectVariable = () => {
        const variable = variablesMissing.find(v => contract.isMigrated ?  v._id === _id : v.apiName === apiName)
        const value = variable?.value;
        selectVariable({value})
    }
    const selectVariable = useCallback(({value} = {}) => {
        const parsedValue = type === 'date' ? format(value, 'PPP', { locale }) : value;
        
        const selector = contract.isMigrated && !isAgendaProperty ? `[data-element-id="${_id}"]` : `[data-apiname="${apiName}"]`

        const previewVarList = document.querySelectorAll(selector);
        
        for (const previewVar of previewVarList) {
            previewVar.innerHTML = parsedValue || name;
            previewVar.classList.add('bg-warning');
        }
    }, [_id, apiName, contract.isMigrated, isAgendaProperty, locale, name, type])

    const onChange = useCallback((eventOrDate) => {
        const value = type === 'date' ? eventOrDate : eventOrDate.target.value;

        const isVariableFilled = getIsVariableFilled({ isLimitRequired, limit, value })

        if (isVariableFilled) {
            dispatch({ type: SET_MISSING_VARS, apiName, variableId: _id, value,  })
        } else {
            dispatch({ type: SET_MISSING_VARS, apiName, variableId: _id, value:'' })
        }
        setIsVariableFilled(isVariableFilled)
        // TODO: REMOVE WHEN MIGRATED TO SLATE -->
        selectVariable({ value })
        
    }, [type, apiName, limit, isLimitRequired, dispatch, _id, selectVariable]);

    const handleBlur = () => {
        const selector = contract.isMigrated && !isAgendaProperty ? `[data-element-id="${_id}"]` : `[data-apiname="${apiName}"]`
        const previewVarList = document.querySelectorAll(selector);
        
        for (const previewVar of previewVarList) {
            previewVar.classList.remove("bg-warning");
        }
    }

    const handleClick = () => {
        scrollToNode(editor, variable)
    }

     if (!_id) return null;

    return (
        <div key={_id || apiName} id="complete-sidebar">
            <div
                className={clsx('form-group border rounded', isVariableFilled ? 'border-success' : 'border-danger')}
                name="box-complete" id="box-complete" onClick={handleClick}>
                <label htmlFor="exampleInputEmail1" className="bg-grey border-bottom w-100 mb-0 py-2 px-3">
                    {
                        isVariableFilled ?
                            <i className="fas fa-check-circle text-success mr-2" id="icon-complete2"></i> :
                            <i className="far fa-circle text-danger mr-2" id="icon-complete"></i>
                    }
                    {name}</label>
                    <VariableInput 
                        variable={{...variable, type}}
                        onChange={onChange}
                        control={methods.control}
                        documentLanguage={locale}
                        onBlur={handleBlur}
                        prefix={variableName}
                        onCalendarOpen={handleSelectVariable}
                        onCalendarClose={handleBlur}
                    />
                {/* {variable.type === 'fixed' ?
                    <select
                        defaultValue={value || variablesMissing.find(vm => vm.apiName === apiName)?.value}
                        onChange={onChange}
                        onBlur={handleBlur}
                        name={variableName}
                        ref={methods.register({ required })}
                        className="form-control"
                    >
                        <option value=''></option>
                        {
                            variable.options?.map((v, index) => <option key={`variable${v}${index}`} value={v}>{v}</option>)
                        }
                    </select>
                    : type !== 'ocr:ine' ?
                        <input
                            defaultValue={value || variablesMissing.find(vm => vm.apiName === apiName)?.value}
                            onChange={onChange}
                            onBlur={handleBlur}
                            name={variableName}
                            ref={methods.register({ required })}
                            maxLength={type === 'text' && limit ? limit : 10000}
                            type={type}
                            className="form-control input-sm"
                            placeholder={name}
                        />
                        : null
                } */}
            </div>
        </div>
    )

}

export default function CompleteTab() {

    const { contract } = useSignState();

    const variables = contract.signViewOptions?.currentParticipant?.variablesMissing;
    const attachments = contract.signViewOptions?.currentParticipant?.attachmentsMissing;

    const { t } = useTranslation();

    const methods = useForm({ mode: 'all' });

    return (
        <FormProvider {...methods}>
            <div className="complete-title mb-4 border-bottom">
                <span className="">
                    {t('sign.contract.complete_description')}
                </span>
            </div>
            {variables.map((variable) =>
                <Variable
                    variable={variable}
                    key={variable.apiName}
                />
            )}
            <ul className="list-group">
                {attachments.length ?
                    attachments.map((attachment) =>
                        <AttachmentItem
                            attachment={attachment}
                            key={attachment._id}
                        />
                    ) :
                    <li className="list-group-item">
                        <span className="empty-attachments">
                            {t('sign.contract.attachment_empty')}
                        </span>
                    </li>
                }
            </ul>
        </FormProvider>
    );
}